import { useGlobalStore } from "@hooks/useGlobalStore";
import { isWeb } from "@memorang/helpers/platform";
import Box from "@memorang/ui/components/Box";
import SnackBarCustom from "@memorang/ui/components/CustomSnackbar";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import { Card, Portal } from "react-native-paper";
/* ======== Components ========= */
import ProfileView from "../components/Profile/ProfileView";
/* ======== Hooks ========= */
import useProfile from "../hooks/useProfile";

const ProfileContainer = () => {
	const { profileDetails } = useProfile();

	const { headerStats, statsTabData } = profileDetails || {};

	const setShowAvatarUpdatedMessage = useGlobalStore(
		(state) => state.setShowAvatarUpdatedMessage,
	);

	const showAvatarUpdatedMessage = useGlobalStore(
		(state) => state.showAvatarUpdatedMessage,
	);

	const Wrapper = isWeb ? Card : Box;
	return (
		<ScrollContainer
			contentContainerStyle={{
				flexGrow: 1,
				paddingBottom: 40,
			}}
			maxWidth="sm"
		>
			<Wrapper
				style={{
					marginTop: 16,
				}}
				height="100%"
				flexGrow={1}
			>
				<ProfileView statsTabData={statsTabData} headerStats={headerStats} />
			</Wrapper>
			{showAvatarUpdatedMessage && (
				<Portal>
					<SnackBarCustom
						message="Avatar updated successfully"
						duration={2000}
						visible
						usePortal={false}
						handleDismiss={() => {
							setShowAvatarUpdatedMessage(false);
						}}
					/>
				</Portal>
			)}
		</ScrollContainer>
	);
};

export default ProfileContainer;
